import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// Small circular help icon with a champagne rim. Hover or focus reveals a
// glass tooltip that explains a control without cluttering the label.
// Use next to complex thresholds, sync configs, cost-alert triggers.
export default function HelpTip({ text, testId, side = "top", className = "" }) {
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="More info"
            data-testid={testId || "help-tip"}
            className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-white/50 hover:text-white/90 transition-colors align-middle ${className}`}
          >
            <HelpCircle className="w-3.5 h-3.5" strokeWidth={1.6} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-[260px] text-xs leading-relaxed p-3 rounded-lg"
          style={{
            background: "linear-gradient(180deg, rgba(24,20,14,0.95), rgba(14,12,9,0.96))",
            border: "1px solid rgba(232,207,154,0.35)",
            color: "rgba(240, 232, 216, 0.92)",
          }}
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
